export default __webpack_public_path__ + "static/media/extension_pic.d8164309.png";